"use strict";
// source
// https://github.com/AGCO-OneDigital/ecosystem-service-graphql/blob/master/src/main/resources/schema/schema.graphqls
Object.defineProperty(exports, "__esModule", { value: true });
exports.ETaskStatus = void 0;
var ETaskStatus;
(function (ETaskStatus) {
    ETaskStatus["DRAFT"] = "DRAFT";
    ETaskStatus["PLANNED"] = "PLANNED";
    ETaskStatus["COMPLETED"] = "COMPLETED";
    ETaskStatus["CLOSED"] = "CLOSED";
})(ETaskStatus = exports.ETaskStatus || (exports.ETaskStatus = {}));
